<ng-container *transloco="let translate">
	<ng-container *clientScreen="let isDesktop = isDesktop">
		@if (
			{
				username: username$ | async,
			};
			as vm
		) {
			<base-modal #baseModal [fullSize]="true" [showClose]="true" (closed)="_onModalClosed()">
				<div class="w-full h-full flex flex-col items-start justify-start text-center">
					<div class="pb-2 flex-none text-l w-full fc-400 font-bold">
						{{ translate('home.getting_started.congratulations') }}
					</div>
					<div
						class="pb-2 flex-none w-full font-bold"
						[style.fontSize]="isDesktop ? 'calc(2 * var(--fs-m))' : 'var(--fs-icon)'"
					>
						{{ translate('home.getting_started.title') }}
					</div>
					<div class="pb-0.5 flex-none text-m leading-xl w-full fc-400">
						{{
							translate('home.getting_started.description', { username: vm.username })
						}}
					</div>
					<div class="py-2 flex-auto overflow-hidden w-full box-border">
						<div class="overflow-hidden w-full h-full flex items-center justify-center">
							<reach-youtube-player
								class="w-full h-full"
								[autoplay]="false"
								[inline]="true"
								[fullSize]="true"
								videoId="rF_OLxkdDb4"
							></reach-youtube-player>
						</div>
					</div>
					<div class="pt-0.5 flex-none text-xs w-full fc-400">
						<span
							[innerHTML]="
								translate('home.getting_started.footer', {
									mailLink: 'mailto:chris@rea.ch',
									pageLink:
										'https://chat.rea.ch/widget/711e84b0-dfb7-4585-b5eb-afeb96e6542f',
								})
							"
						></span>
					</div>
				</div>
				<div
					ngProjectAs="[footer]"
					class="pt-2 w-full flex items-center"
					[class.justify-end]="isDesktop"
					[class.justify-center]="!isDesktop"
				>
					<button uiNewButtonFilled (click)="baseModal?.close()">
						{{ translate('home.getting_started.start') }}
					</button>
				</div>
			</base-modal>
		}
	</ng-container>
</ng-container>
